import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { ProductViewDetailsQuoteAttributesComponent } from './attributes/product-view-details-quote-attributes.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ButtonStyleComponent } from '../../../../../common/buttons/button-style/button-style.component';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { NProductViewRequestQuoteModal } from '../../request-quote/modal/product-view-request-quote-modal.component';
import { UiComponent } from '@df/ui/ui.component';
import { DfApiConfigService } from '@df/api/config/df-api-config.service';
import { Product } from '../../../product.decorator';

@Component({
    selector: 'product-view-details-quote',
    templateUrl: './product-view-details-quote.html',
    standalone: true,
    imports: [ProductViewDetailsQuoteAttributesComponent, TranslationModule, ButtonStyleComponent, CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewDetailsQuoteComponent extends UiComponent implements OnInit {
    @Input({
        required: true
    })
    product!: Product<IProductDataV3>;

    private timeoutId?: number;

    requestQuoteMessage: string | undefined = '';

    private dfModalService = inject(DfModalService);

    private dfApiConfigService = inject(DfApiConfigService);

    override ngOnInit(): void {
        super.ngOnInit();
        this.dfApiConfigService.loadCountries();
    }

    protected get bottomText(): string | undefined {
        return this.requestQuoteMessage || this.leadTime;
    }

    private get leadTime(): string | undefined {
        return this.product.getAttr('lead_time');
    }

    protected openRequestQuoteModal(): void {
        this.dfModalService.open(undefined, NProductViewRequestQuoteModal.BLOCK_ID, this.product.requestModalVariant, (message: string) => {
            this.onRequestQuoteSuccess(message);
        });
    }

    private onRequestQuoteSuccess(message: string): void {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
        this.requestQuoteMessage = message;
        this.timeoutId = this.timeoutService.setTimeout(() => {
            this.requestQuoteMessage = undefined;
            this.detectChanges();
        }, 10000);
        this.detectChanges();
    }
}
